/**
 * The curated service-icon set (lucide names) — mirrors the backend
 * BookingPageServiceIcons allowlist exactly.
 */
export const BOOKING_PAGE_SERVICE_ICONS = [
  "Music",
  "Mic",
  "BookOpen",
  "GraduationCap",
  "Languages",
  "Dumbbell",
  "HeartPulse",
  "Palette",
  "Camera",
  "Code",
  "Calculator",
  "Globe",
  "Users",
  "Star",
  "Target",
  "Trophy",
] as const;

export type BookingPageServiceIcon = (typeof BOOKING_PAGE_SERVICE_ICONS)[number];

export const isBookingPageServiceIcon = (value: string): value is BookingPageServiceIcon =>
  (BOOKING_PAGE_SERVICE_ICONS as readonly string[]).includes(value);
